import { StorageHelper, StorageType } from "./storage";

export class SessionStorageHelper extends StorageHelper {
  public static init() {
    super.init();
    super.setStorage(sessionStorage, StorageType.SessionStorage);
  }
}

SessionStorageHelper.init();
